import React, { FC, useEffect, useState } from "react";

import { Stack } from "@mui/material";

import Header from "../../../components/Header";
import SaveButton from "../../../components/SaveButton";
import SettingSection from "../../../components/SettingSection";
import TextField from "../../../components/styled/TextField";
import { pushSuccess } from "../../../slices/notifications";
import { useDispatch } from "../../../store";
import {
  Organization,
  useUpdateOrganizationMutation,
} from "../../../store/pomeriumApi";

interface Props {
  org: Partial<Organization>;
}

const General: FC<Props> = ({ org }) => {
  const [updateOrg] = useUpdateOrganizationMutation();
  const dispatch = useDispatch();
  const [name, setName] = useState<string>(org?.name || "");

  useEffect(() => {
    setName(org?.name || "");
  }, [JSON.stringify(org)]);

  const handleSave = async () => {
    const resp = await updateOrg({
      organizationId: org?.id || "",
      updateOrganizationRequest: { name },
    }).unwrap();
    if (resp?.id) {
      dispatch(pushSuccess("Organization Updated"));
    }
  };

  if (!org?.id) {
    return <></>;
  }

  return (
    <>
      <Header title="General Settings" breadcrumbs={false} />
      <Stack>
        <SettingSection label="Name" docsKey="">
          <TextField
            error={!name}
            fullWidth
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setName(e.target.value)
            }
          />
        </SettingSection>
        <Stack direction="row" justifyContent={"right"}>
          <SaveButton
            variant="contained"
            type="button"
            color="primary"
            onClick={handleSave}
            disabled={!name || org?.name === name}
          >
            Save
          </SaveButton>
        </Stack>
      </Stack>
    </>
  );
};

export default General;
